import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { OkResponse } from './types/common'
import type { CreateDealNoteBody, DealNote, ListDealNotesResponse } from './types/deal'

export const dealNotesApi = createApi({
	reducerPath: 'dealNotesApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['DealNote'],
	endpoints: (builder) => ({
		listDealNotes: builder.query<ListDealNotesResponse, string>({
			query: (dealId) => `/crm/deals/${dealId}/notes`,
			providesTags: (_r, _e, dealId) => [{ type: 'DealNote', id: dealId }],
		}),

		createDealNote: builder.mutation<
			DealNote | null,
			{ dealId: string; body: CreateDealNoteBody }
		>({
			query: ({ dealId, body }) => ({
				url: `/crm/deals/${dealId}/notes`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (_r, _e, { dealId }) => [{ type: 'DealNote', id: dealId }],
		}),

		deleteDealNote: builder.mutation<OkResponse, { dealId: string; noteId: string }>({
			query: ({ dealId, noteId }) => ({
				url: `/crm/deals/${dealId}/notes/${noteId}`,
				method: 'DELETE',
			}),
			invalidatesTags: (_r, _e, { dealId }) => [{ type: 'DealNote', id: dealId }],
		}),
	}),
})

export const {
	useListDealNotesQuery,
	useCreateDealNoteMutation,
	useDeleteDealNoteMutation,
} = dealNotesApi
